import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import useCheckoutPointsEarned from 'pages/Checkout/hooks/useCheckoutPointsEarned';

const PointsEarnSummary = ({ pointsEarned: initialPointsEarned }) => {
  const { pointsEarned } = useCheckoutPointsEarned({ pointsEarned: initialPointsEarned });

  return (
    <Text display="block" fontSize="sm">
      Earn <PointsEarnDisplay total={pointsEarned.qffPoints.total} base={pointsEarned.qffPoints.base} data-testid="total-qff-points" />{' '}
      Qantas Points^ plus <PointsEarnDisplay total={pointsEarned.qbrPoints.total} data-testid="total-qbr-points" /> Qantas Points for your
      business*.
    </Text>
  );
};

PointsEarnSummary.propTypes = {
  pointsEarned: PropTypes.object.isRequired,
};

export default PointsEarnSummary;
